import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function PageTitle() {
  const location = useLocation();

  useEffect(() => {
    const titles = {
      "/": "SPT | Inicio",
      "/proposals": "SPT | Propuestas",
      "/familia": "SPT | Familia Banner",
      "/team": "SPT | Equipo",
      "/events": "SPT | Eventos",
      "/news": "SPT | Noticias",
      "/dashboard": "SPT | Dashboard",
      "/salud": "SPT | Salud Ciudadana",
      "/despacho": "SPT | Despacho Municipal",
      "/suggestions": "SPT | Sugerencias",
      "/gamification": "SPT | Participación Ciudadana"
    };

    document.title = titles[location.pathname] || "SPT | Plataforma Ciudadana";

  }, [location.pathname]);

  return null;
}